import React from "react";

export const ForgotPasswordForm = ({
  handleChange,
  handleSubmitUser,
  handleSubmitEmail,
  handleSubmit,
  loading,
  credentials,
  lang,
}) => {
  return (
    <>
      <form
        onSubmit={handleSubmit}
        action="https://par.tuclase.cl/login/index.php"
        method="post"
      >
        <div className="col-md-12">
          <input
            onChange={handleChange}
            name="email"
            className="form-control box-ingreso2"
            placeholder={lang["Recovery"].second_send}
            value={credentials}
          />
        </div>
        <div className="col-md-12">
          <button
            type="submit"
            className="btn btn-primary btn-lg btn-block bot-text"
          >
            {loading ? (
              <span
                className="spinner-border spinner-border-md mx-3"
                role="status"
                aria-hidden="true"
              ></span>
            ) : (
              <>{lang["Recovery"].third_send}</>
            )}
          </button>
        </div>
      </form>
    </>
  );
};
